<div *ngIf="error$ | async as error" class="error-banner">
  {{ error }}
</div>

<div class="container-fluid behind">
    <div class="section-heading pplBehindVis">
      <u>&nbsp;&nbsp;People</u>&nbsp;<u>Behind the Vision&nbsp;&nbsp;</u>
    </div>

    <!-- ================= CHAIRMAN ================= -->

    <div class="row align-items-center message-row" id="CHAIRMAN" *ngIf="chairmanContent">

      <div class="col-lg-7 col-12 order-1">

        <div class="message-title">
          {{ chairmanContent?.pageTitle || "Chairman's Message" }}
        </div>

        <div class="message-text">

          <ng-container *ngIf="chairmanContent as cc; else defaultChairmanMessage">
            <div
              class="collapsible-content"
              [class.collapsed]="!showChairmanMessage"
              [innerHTML]="cc.content">
            </div>
          </ng-container>

          <ng-template #defaultChairmanMessage>
            <div class="collapsible-content" [class.collapsed]="!showChairmanMessage">
              Dear Parents, Students, and Well-Wishers,<br />
              It is my privilege to welcome you to
              <b>{{ (school?.schName || '') | titlecase }}</b>,
              an institution committed to nurturing young minds and shaping future leaders.
              We believe that education is the foundation upon which individuals build their character, values, and aspirations. Our vision extends beyond academic excellence to developing responsible, confident, and compassionate citizens who can contribute meaningfully to society.
              In a rapidly changing world, it is essential that students are equipped not only with knowledge but also with critical thinking, creativity, leadership, and strong moral values. Our dedicated educators work tirelessly to provide a learning environment that inspires curiosity, innovation, and lifelong learning.
              We remain committed to providing quality education, modern facilities, and opportunities that enable every child to discover and realize their fullest potential.
              I sincerely thank our parents, teachers, and staff for their continued trust, dedication, and partnership in this shared journey of excellence.
              Wishing every student success, happiness, and a bright future ahead.
            </div>
          </ng-template>

          <a (click)="showChairmanMessage = !showChairmanMessage" class="read-more-link">
            {{ showChairmanMessage ? '(Read Less)' : '...(Read More)' }}
          </a>

        </div>

      </div>

      <div class="col-lg-5 col-12 order-2 text-center">

        <div
          class="d-flex"
          [ngClass]="
            chairman?.image?.[0]?.descp
              ? 'flex-column flex-md-row justify-content-start'
              : 'flex-column justify-content-center align-items-center'
          "
          style="
            background-color: rgb(181, 192, 201);
            margin:5px;
            border-radius:10px;
            max-width:700px;
            color:black;
          ">

          <div
            [ngStyle]="{
              'margin-left': chairman?.image?.[0]?.descp ? '15px' : '0'
            }">

            <img
              class="profile-img"
              [src]="chairmanImage || 'assets/placeholder-user.jpg'"
              alt="Chairman">

            <div class="person-name text-center">
              {{ (chairman?.image?.[0]?.file?.title || '') | titlecase }}
              <br />
              <span style="color:black">Chairman</span>
            </div>

          </div>

          <div
            *ngIf="chairman?.image?.[0]?.descp"
            style="
              margin-top:40px;
              margin-left:10px;
              margin-right:10px;
              font-size:20px;
              text-align:justify;
            ">

            <span style="line-height:1.7em;">
              {{ chairman?.image?.[0]?.descp }}
            </span>

          </div>

        </div>

      </div>

    </div>
    <!-- ================= DIRECTOR ================= -->
    <div class="row align-items-center message-row" id="director">
      <div class="col-lg-7 col-12 order-lg-2 order-1 py-2">
        <div class="message-title">
          {{ directorContent?.pageTitle || "Director's Message" }}
        </div>

        <div class="message-text">

          <!-- CASE 1: Director content exists -->
          <ng-container *ngIf="directorContent as dc; else defaultMessage">
            <div
              class="collapsible-content"
              [class.collapsed]="!showDirectorMessage"
              [innerHTML]="dc.content">
            </div>
          </ng-container>

          <!-- CASE 2: Fallback hardcoded message -->
          <ng-template #defaultMessage>
            <div
              class="collapsible-content"
              [class.collapsed]="!showDirectorMessage">
              Dear Parents and Students, <br />
              Education is not just a path to academic achievement; it is a powerful force
              that shapes character and opens doors to opportunity.
              At <b>{{ (school?.schName || '') | titlecase }}</b>, we remain dedicated to
              recognising the unique potential of every learner and fostering a genuine
              love for learning.
              <br />
              Our aim has always been to provide a warm, inclusive, and forward-looking
              environment where students feel motivated, confident, and prepared to
              embrace the future.
              <br />
              We emphasise holistic development — nurturing academics alongside
              co-curricular engagement and essential life skills.
              <br />
              Thank you for your continued trust in us.
            </div>
          </ng-template>

          <!-- Read More / Less (shared) -->
          <a
            (click)="showDirectorMessage = !showDirectorMessage"
            class="read-more-link">
            {{ showDirectorMessage ? '(Read Less)' : '...(Read More)' }}
          </a>

        </div>
      </div>


      <div class="col-lg-5 col-12 order-lg-1 order-2 text-center">
        <div
          class="d-flex"
          [ngClass]="
            director?.image?.[0]?.descp
              ? 'flex-column flex-md-row justify-content-start'
              : 'flex-column justify-content-center align-items-center'
          "
          style="background-color: rgb(181, 192, 201); margin:5px; border-radius: 10px; max-width:700px"
        >

          <!-- Image + Name -->
          <div
            [ngStyle]="{
              'margin-left': director?.image?.[0]?.descp ? '15px' : '0'
            }"
          >
            <img
              class="profile-img"
              [src]="directorImage || 'assets/placeholder-user.jpg'"
              alt="Director"
            />

            <div class="person-name text-center">
              {{ (director?.image?.[0]?.file?.title || '') | titlecase }}
              <br />
              <span style="color:black">Director</span>
            </div>
          </div>

          <!-- Description -->
          <div
            *ngIf="director?.image?.[0]?.descp"
            style="margin-top:40px; margin-left:10px; font-size:20px; text-align: justify; margin-right:10px"
          >
            <span style="line-height:1.7em;">
              {{ director?.image?.[0]?.descp }}
            </span>
          </div>

        </div>
      </div>

    </div>


    <!-- Principal Section -->
    <div class="row align-items-center message-row" id="PRINCIPAL">

      <div class="col-lg-5 col-12 order-2 text-center">
        <div
          class="d-flex"
          [ngClass]="principal?.image?.[0]?.descp ?
                    'flex-column flex-md-row justify-content-start' :
                    'flex-column justify-content-center align-items-center'"
          style="background-color: rgb(181, 192, 201);
                margin:5px;
                border-radius:10px;
                max-width:700px;
                color:black"
        >

          <!-- Image + Name -->
          <div [ngStyle]="{ 'margin-left': principal?.image?.[0]?.descp ? '15px' : '0' }">
            <img
              class="profile-img"
              [src]="principalImage || 'assets/placeholder-user.jpg'"
              alt="Principal"
            />
            <div class="person-name text-center">
              {{ (principal?.image?.[0]?.file?.title || '') | titlecase }}
              <br />
              <span style="color:black">Principal</span>
            </div>
          </div>

          <!-- Description (only if present) -->
          <div
            *ngIf="principal?.image?.[0]?.descp"
            style="margin-top:40px;
                  margin-left:10px;
                  font-size:20px;
                  text-align:justify;
                  margin-right:10px"
          >
            <span style="line-height:1.7em;">
              {{ principal?.image?.[0]?.descp }}
            </span>
          </div>

        </div>
      </div>

    
      <div class="col-lg-7 col-12 order-1">
        <div class="message-title">
          {{ principalContent?.pageTitle || "Principal's Message" }}
        </div>

        <div class="message-text">

          <!-- CASE 1: Principal content exists -->
          <ng-container *ngIf="principalContent as pc; else defaultPrincipalMessage">
            <div
              class="collapsible-content"
              [class.collapsed]="!showPrincipalMessage"
              [innerHTML]="pc.content">
            </div>
          </ng-container>

          <!-- CASE 2: Fallback hardcoded message -->
          <ng-template #defaultPrincipalMessage>
            <div
              class="collapsible-content"
              [class.collapsed]="!showPrincipalMessage">
              Dear Parents and Students, <br />
              Education is a journey of gaining knowledge, skills, values, and the habits
              that shape one’s character. Its true purpose goes beyond securing a
              livelihood — it teaches us how to lead life with meaning and purpose.
              <br />
              A teacher’s role is to spark curiosity so that children continue to learn
              long after they leave the classroom. I believe every child must have the
              freedom to make mistakes, for it is through those mistakes that real
              learning happens.
              <br />
              At <b>{{ (school?.schName || '') | titlecase }}</b>, we strive to make
              learning joyful, enriching, and engaging. Over the years, our commitment to 
              this vision has reflected in excellent board results, achievements in sports, 
              and active involvement in co-curricular activities.
              <br />
              Our school ensures abundant opportunities for students to develop values
              such as honesty, leadership, responsibility, and acceptance of others.
              <br />
              I extend my warm wishes to all our students and hope they continue to rise
              and succeed in every step of their journey.
            </div>
          </ng-template>

          <!-- Read More / Less -->
          <a
            (click)="showPrincipalMessage = !showPrincipalMessage"
            class="read-more-link"
          >
            {{ showPrincipalMessage ? '(Read Less)' : '...(Read More)' }}
          </a>

        </div>
      </div>
    </div>

    <!-- Other People Section -->
    <div class="row align-items-center message-row" id="director" *ngIf="otherPeople">
      
      <div style="display:flex;flex-wrap: wrap;justify-content: space-around;">
        <div  *ngFor="let people of otherPeople">
          <div class="d-flex flex-column flex-md-row" style="background-color: rgb(181, 192, 201);margin:5px;  border-radius: 10px;max-width:700px">

            <div class=" text-center" style="margin:10px">
              <div style="margin-left:10px">
                <img
                  class="profile-img"
                  [src]="people.imageUrl || 'assets/placeholder-user.jpg'"
                  [alt]="people.designation"
                />
              </div>
              <div class="person-name">
                {{people?((people.name||'')|titlecase):''}} <br />
                <span style="color:rgba(0, 0, 0, 0.575)">{{people.designation|titlecase}}</span>
              </div>
            </div>

            <div style="margin-top:40px; margin-left:10px;font-size: 20px; text-align: justify;margin-right:10px">
              <span  style="text-align: justify;line-height:1.7em;">{{people.description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</div>